import { MIN_LEN } from "@/constants";

export type QueryPrimitive = string | number | boolean | null | undefined;

export function buildQuery(params: Record<string, QueryPrimitive>): string {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null) return;

    const stringValue = typeof value === 'string' ? value.trim() : String(value);
    if (stringValue.length === MIN_LEN) return;

    searchParams.set(key, stringValue);
  });

  const queryString = searchParams.toString();
  return queryString.length > MIN_LEN ? `?${queryString}` : '';
}

export function buildQueryString(
  params?: Record<string, string | number | boolean | null | undefined>,
): string {
  if (params === undefined) return '';

  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === null || value === undefined) return;
    searchParams.set(key, String(value));
  });

  const serialized = searchParams.toString();
  return serialized.length > MIN_LEN ? `?${serialized}` : '';
}
